module.exports = __webpack_public_path__ + "img/mg-jp.f734cae0.png";